import React, {useEffect, useState, Suspense} from 'react';
import Stack from "@mui/material/Stack";
import useJumboLayoutSidebar from "@jumbo/hooks/useJumboLayoutSidebar";
import AuthUserDropdown from "../../../../shared/widgets/AuthUserDropdown";
import {Box, IconButton} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import Logo from "../../../../shared/Logo";
import {SIDEBAR_STYLES, SIDEBAR_VARIANTS} from "@jumbo/utils/constants";
import useJumboHeaderTheme from "@jumbo/hooks/useJumboHeaderTheme";
import {StorageService} from "../../../../services/StorageService";
import useJumboTheme from "../../../../../@jumbo/hooks/useJumboTheme";
import useJumboSidebarTheme from "../../../../../@jumbo/hooks/useJumboSidebarTheme";
import useJumboFooterTheme from "../../../../../@jumbo/hooks/useJumboFooterTheme";
import {mainTheme as mainThemeDark} from "../../../../themes/main/dark";
import {headerTheme as headerThemeDark} from "../../../../themes/header/dark";
import {sidebarTheme as sidebarThemeDark} from "../../../../themes/sidebar/dark";
import {footerTheme as footerThemeDark} from "../../../../themes/footer/dark";
import {mainTheme as mainThemeDefault} from "../../../../themes/main/default";
import {headerTheme as headerThemeDefault} from "../../../../themes/header/default";
import {sidebarTheme as sidebarThemeDefault} from "../../../../themes/sidebar/default";
import {footerTheme as footerThemeDefault} from "../../../../themes/footer/default";
import {useNavigate} from "react-router-dom";
import {getSupportedLocale} from "../../../../utils/locales";
import {useTranslation} from "react-i18next";

const Header = () => {
    const {sidebarOptions, setSidebarOptions} = useJumboLayoutSidebar();
    const {theme, setTheme, setMuiLocale} = useJumboTheme();
    const {headerTheme, setHeaderTheme} = useJumboHeaderTheme();
    const {setSidebarTheme} = useJumboSidebarTheme();
    const {setFooterTheme} = useJumboFooterTheme();
    const navigate = useNavigate();


    const user = StorageService.loadUser();

    const {i18n} = useTranslation();
    const themeColor = StorageService.loadAppThemeColor() || 'light';

    useEffect(async () => {
        if (!user) {
            navigate('/login', {replace: true});
        }

        if(themeColor === 'dark') {
            await setTheme({mode: "dark", ...mainThemeDark});
            setHeaderTheme({...theme, ...headerThemeDark});
            setSidebarTheme({...theme, ...sidebarThemeDark});
            setFooterTheme({...theme, ...footerThemeDark});
        }
        else {
            await setTheme({mode: "light", ...mainThemeDefault});
            setHeaderTheme({...theme, ...headerThemeDefault});
            setSidebarTheme({...theme, ...sidebarThemeDefault});
            setFooterTheme({...theme, ...footerThemeDefault});
        }

        const supportedLocale = getSupportedLocale(user?.locale)

        await i18n.changeLanguage(user?.locale);

        setMuiLocale(supportedLocale.muiLocale);


    }, []);



    const handleThemeChange = React.useCallback(async (theme) => {
        StorageService.saveAppThemeColor(theme);
        if(theme === 'dark') {
            await setTheme({mode: "dark", ...mainThemeDark});
            setHeaderTheme({...theme, ...headerThemeDark});
            setSidebarTheme({...theme, ...sidebarThemeDark});
            setFooterTheme({...theme, ...footerThemeDark});
            return;
        }
        await setTheme({mode: "light", ...mainThemeDefault});
        setHeaderTheme({...theme, ...headerThemeDefault});
        setSidebarTheme({...theme, ...sidebarThemeDefault});
        setFooterTheme({...theme, ...footerThemeDefault});
    }, []);

    return (
        <React.Fragment>
            {
                (
                    sidebarOptions.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER
                    || sidebarOptions.variant === SIDEBAR_VARIANTS.TEMPORARY
                    || (sidebarOptions.variant === SIDEBAR_VARIANTS.PERSISTENT && !sidebarOptions.open)
                ) &&
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        sx={{
                            ml: sidebarOptions.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER ? -2 : 0,
                            mr: 3,
                        }}
                        onClick={() => setSidebarOptions({open: !sidebarOptions.open, anchor: 'left', hide: false})}
                    >
                        {
                            sidebarOptions?.open ? <MenuOpenIcon/> : <MenuIcon/>
                        }
                    </IconButton>
            }
            {
                sidebarOptions?.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER &&
                <Logo sx={{mr: 3}} mode={headerTheme.type ?? "light"}/>
            }

            <Stack direction="row" alignItems="center" spacing={1.25} sx={{ml: "auto"}}>


                {/*{(theme?.mode === 'light'|| theme?.mode === undefined) && (*/}
                {/*    <JumboIconButton elevation={25} onClick={() => handleThemeChange('dark')}>*/}
                {/*        <LightModeIcon  sx={{fontSize: '1.25rem', cursor: 'pointer'}}/>*/}
                {/*    </JumboIconButton>*/}
                {/*)}*/}

                {/*{theme?.mode === 'dark' && (*/}
                {/*    <JumboIconButton elevation={25} onClick={() => handleThemeChange('light')}>*/}
                {/*        <DarkModeIcon  sx={{fontSize: '1.25rem', cursor: 'pointer'}}/>*/}
                {/*    </JumboIconButton>*/}
                {/*)}*/}



                <Suspense fallback={<Box/>}>
                    <AuthUserDropdown/>
                </Suspense>
            </Stack>
        </React.Fragment>
    );
};

export default Header;
